import { render, staticRenderFns } from "./VTwoCaseStudies.vue?vue&type=template&id=32c6e19e"
import script from "./VTwoCaseStudies.vue?vue&type=script&lang=js"
export * from "./VTwoCaseStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports